// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { specificationsStyles } from "@conklin/Overrides/Widgets/ProductDetails/ProductDetailsSpecifications";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, hideElementOnPrint, xScreen } from "@conklin/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

specificationsStyles.tablesWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        column-gap: 16px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};
specificationsStyles.tableContainer = {
    css: css`
        display: flex;
        width: calc(50% - 8px);
        ${xScreen("lte", "md")} {
            width: 100%;
            ${({ startPositionIsOdd }: any) => {
                if (startPositionIsOdd) {
                    return css`
                        tr:nth-child(odd) {
                            background: ${color("common.ui2")};
                        }
                        tr:nth-child(even) {
                            background: ${color("common.ui1")};
                        }
                    `;
                }
            }}
        }

        @media print {
            flex: 1;
            width: 100%;
        }
    `,
};
specificationsStyles.valueCell = {
    css: css`
        white-space: normal;
        width: 50%;
        vertical-align: baseline;
        ${xScreen("lte", "md")} {
            text-align: right;
        }
    `,
};
specificationsStyles.labelCell = {
    css: css`
        width: 50%;
        vertical-align: baseline;
    `,
};
specificationsStyles.label = {
    size: 14,
    lineHeight: "17px",
    weight: fontConfig.weight.bold,
};
specificationsStyles.value = {
    size: 14,
    lineHeight: "17px",
};

specificationsStyles.specificationsAccordionSection = {
    headerProps: {
        css: css`
            @media print {
                ${TypographyStyle} {
                    color: ${color("text.main")};
                }
            }
        `,
    },
    panelProps: {
        css: css`
            [class^="ListItemStyle"]::marker {
                color: ${color("primary.main")};
            }
        `,
    },
};
